import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Container,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { BsChevronDown } from "react-icons/bs";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { RiSearch2Line } from "react-icons/ri";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../../components/common/Loading";
import AdminHelpers from "../../../services/admin/admin.service";

const ProgramCluster = () => {
  const navigate = useNavigate();
  const { course_id } = useParams();

  const [loading, setLoading] = useState(true);
  const [traineeProgCluster, setTraineeProgCluster] = useState<any[]>([]);
  const [traineeProgClusterCourse, setTraineeProgClusterCourse] =
    useState<string>("");
  const [courseId, setCourseId] = useState("");

  useEffect(() => {
    if (course_id) setCourseId(course_id);
    AdminHelpers.getProgramCluster(course_id)
      .then((response) => {
        setTraineeProgCluster(response.data);
                setTraineeProgClusterCourse(response.data[0].course_name);
        setLoading(false);
      })
      .catch((err) => err);
  }, []);

  return (
    <Box minHeight="100vh" bg="#F9F8F8">
      {loading ? (
        <Loading />
      ) : (
        <Container
          width={"75%"}
          maxWidth={"84%"}
          px={0}
          pt="100px"
          right={0}
          bg="F9F8F8"
          mx="auto"
        >
          <Box
            mb="10px"
            display="flex"
            alignItems="center"
            border="1px solid #616161"
            px="5px"
            py="7px"
            width="145px"
            borderRadius="5px"
            cursor="pointer"
          >
            <HiArrowNarrowLeft color="#616161" fontSize="20px" />
            <Text
              fontSize="14px"
              color="#616161"
              pl="5px"
              onClick={() => navigate(-1)}
              fontWeight={700}
            >
              Back to Sessions
            </Text>
          </Box>

          <Box bg="white" px="10px">
            <Flex justifyContent="space-between" alignItems="center" py="26px">
              <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                2023/2024 Session
              </Box>
            </Flex>
            <Text
              color="#616161"
              fontSize="16px"
              fontWeight="400"
              display="block"
            >
              {" "}
              {/* Engineering course */}
              {traineeProgClusterCourse}
            </Text>
            <Flex py="15px" justifyContent="">
              <HStack gap="1rem" w={"100%"}>
                <InputGroup
                  color="brand.subtitle"
                  bg="white"
                  width="30%"
                  mr="20px"
                >
                  <Input
                    height="40px"
                    placeholder="Search trainees"
                    //onChange={(e) => handleSearchChange(e)}
                    fontSize={12}
                    size="sm"
                  />

                  <InputRightElement
                    pointerEvents="none"
                    children={<RiSearch2Line color="red" size="0.9rem" />}
                  />
                </InputGroup>
                <Menu>
                  <MenuButton
                    as={Button}
                    rightIcon={<BsChevronDown />}
                    bg="white"
                    color="#616161"
                    variant={"outline"}
                    size="sm"
                    height={"38px"}
                    fontSize={13}
                    border="1px solid"
                    borderColor="#9E9E9E"
                    borderRadius={"none"}
                  >
                    Sort by name(A-Z)
                  </MenuButton>
                  <MenuList fontSize={12}>
                    <MenuItem>2022/2023</MenuItem>

                    <MenuItem>2021/2022</MenuItem>
                    <MenuItem> 2020/2021</MenuItem>
                    <MenuItem>2019/2020</MenuItem>
                  </MenuList>
                </Menu>
                <Menu>
                  <MenuButton
                    as={Button}
                    rightIcon={<BsChevronDown />}
                    bg="white"
                    color="#616161"
                    variant={"outline"}
                    size="sm"
                    height={"38px"}
                    fontSize={13}
                    border="1px solid"
                    borderColor="#9E9E9E"
                    borderRadius={"none"}
                  >
                    Sort by:Locations
                  </MenuButton>
                  <MenuList fontSize={12}>
                    <MenuItem>Lagos</MenuItem>
                    <MenuItem>Ibadan</MenuItem>
                    <MenuItem>Jos</MenuItem>
                    <MenuItem>Akure</MenuItem>
                    <MenuItem>Kano</MenuItem>
                  </MenuList>
                </Menu>
              </HStack>
            </Flex>

            <Box width="100%">
              <TableContainer>
                <Table variant="simple">
                  <Thead mb="10px">
                    <Tr
                      pb="10px"
                      borderBottom="1px solid"
                      borderColor="#D5D5D5"
                    >
                      <Th width="70px">
                        <Checkbox></Checkbox>
                      </Th>
                      <Th textTransform="none">Trainees</Th>
                      <Th textTransform="none">Email Address</Th>
                      <Th textTransform="none">Locations</Th>
                      <Th textTransform="none">Trainee ID</Th>
                      <Th textTransform="none">Enrollment ID</Th>
                      {/* <Th textTransform="none">Actions</Th> */}
                    </Tr>
                  </Thead>
                  <Tbody>
                    {traineeProgCluster.map((each) => (
                      <Tr bg="white">
                        <Td width="70px">
                          <Checkbox></Checkbox>
                        </Td>
                        <Td>
                          <HStack spacing="10px">
                            <Avatar
                              name={each.trainee.trainee_name}
                              size="sm"
                            />
                            <Text
                              fontWeight="600"
                              fontSize="16px"
                              color="#616161"
                            >
                              {each.trainee.trainee_name}
                              <br></br>
                              {/* Mechanical Engineering */}
                            </Text>
                          </HStack>
                        </Td>
                        <Td>
                          {" "}
                          <Text>{each.trainee.email}</Text>
                        </Td>
                        <Td>
                          {" "}
                          <Text>Lagos,Ibadan</Text>
                        </Td>
                        <Td>
                          {" "}
                          <Text>{each.trainee.traineeID}</Text>
                        </Td>
                        <Td>
                          <Text>{each.trainee.enrollmentID}</Text>
                        </Td>

                        {/* <Td>
                          <HStack>
                            <Button
                              size={"sm"}
                              fontSize={"12px"}
                              colorScheme="red"
                              variant={"outline"}
                              borderColor={"red"}
                              //onClick={() => { openEnrolModal(each.uuid) }}
                            >
                              View Details
                            </Button>
                          </HStack>
                        </Td> */}
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        </Container>
      )}
    </Box>
  );
};

export default ProgramCluster;
